import React from "react";
import { map } from "lodash";
import { pure } from "recompose";

import OnePanelPlus from "./OnePanelPlus";
import Text from "./Text";
import GenericTable from "./GenericTable";
import PricingChart from "components/ceo/analysis/competitive/charts/pricing.js";
import { numberFormat, moneyFormat, moneyFormatCents } from "./format";
import { getTeam, pickValue, getField } from "./utils";
import { dFlexC } from "./styles";
import Auth from "routes/Auth";
import TeamLegend from "./TeamLegend";

const MarketingSellingPrice = pure(
  ({
    competitiveAnalysis,
    teamId,
    unitSales,
    teams,
    products,
    forecasts,
    competitionMetrics,
    rounds,
    round
  }) => {
    const data = competitiveAnalysis || competitionMetrics;
    const field1 = "Average Selling Price - Mobile";
    const field2 = "Average Selling Price - Auto";
    const team = getTeam(teamId, data);
    const units = -team["Units Sold"];
    const price = team["Net Revenues"] / units;
    const mobileData = pickValue(teams, data, field1, "team");
    const autoData = pickValue(teams, data, field2, "team");
    const roundId = rounds.find(i => i.number === round).id;
    const unitSalesFiltered = unitSales.filter(
      i => i.team === teamId && i.round === roundId
    );

    return (
      <OnePanelPlus title="Selling price">
        <fragment>
          <Text>
            Your team sold a total of {numberFormat(units)} units of image
            sensors at a weighted average selling price of{" "}
            {moneyFormatCents(price)}. Below is the breakdown of each of your
            product’s selling prices.
          </Text>
          <GenericTable
            header={[
              { name: "Product Name", highlighted: true },
              { name: "Units Sold (Auto)", highlighted: true },
              { name: "", highlighted: false },
              { name: "Units Sold (Mobile)", highlighted: true },
              { name: "", highlighted: false },
              { name: "Total Units Sold", highlighted: true },
              { name: "", highlighted: false },
              { name: "Selling Price", highlighted: true }
            ]}
            rows={map(
              unitSalesFiltered,
              ({ product, units_sold_auto, units_sold_mobile, units_sold }) => [
                getField("name", "id", products, product),
                numberFormat(-units_sold_auto),
                "+",
                numberFormat(-units_sold_mobile),
                "=",
                numberFormat(-units_sold),
                "@",
                moneyFormat(getField("price", "product", forecasts, product))
              ]
            )}
          />
          <Text>n/a: This product did not sell.</Text>
        </fragment>
        <div style={{ ...dFlexC, alignItems: 'center' }}>
          <div style={{ display: 'flex', flexDirection: 'row', gap: 16, alignItems: 'flex-start', width: '100%' }}>
            <div style={{ flex: 1, minWidth: 0 }}>
              <PricingChart
                title="MOBILE PHONES"
                data={mobileData}
                hideZero={true}
                teams={teams}
              />
            </div>
            <div style={{ flex: 1, minWidth: 0 }}>
              <PricingChart
                title="AUTONOMOUS VEHICLES"
                data={autoData}
                hideZero={true}
                teams={teams}
              />
            </div>
          </div>
          <Text marginTop="15px">SELLING PRICE</Text>
          <TeamLegend teams={teams} />
        </div>
      </OnePanelPlus>
    );
  }
);

export default MarketingSellingPrice;



// WEBPACK FOOTER //
// ./src/components/analysis/MarketingSellingPrice.js